export default __webpack_public_path__ + "static/media/facebook-icon.92ce532d.svg";